import * as React from 'react';
import { Outlet } from 'react-router-dom';

export function ErrorManager(): JSX.Element {
    return <Outlet />;
}
